import { AdminRoutes, MemberRoutes, PublicRoutes } from '../config/routes.config'
import { Navigate } from 'react-router-dom'
import { UserRoles } from '../types/userRoles'
import { SubscriptionStatus } from '../types/userDetails.types'
import { useAtom } from 'jotai'
import { useAuth } from '../hooks/useAuth'
import { userAtom } from '../state/userAtom'

export const RootRedirect: React.FC = () => {
  const { logout } = useAuth()
  const [user] = useAtom(userAtom)

  if (!user) {
    return <Navigate to={PublicRoutes.LOGIN} replace />
  }

  switch (user.role) {
    case UserRoles.MEMBER:
      // Redirect deactivated members to their account profile instead of home
      if (user.subscriptionStatus === SubscriptionStatus.DEACTIVATED) {
        return <Navigate to={MemberRoutes.ACCOUNT_PROFILE} replace />
      }
      return <Navigate to={MemberRoutes.HOME} replace />
    case UserRoles.ADMIN:
      return <Navigate to={AdminRoutes.MEMBERS} replace />
    default:
      logout()
      return <Navigate to="/403" replace />
  }
}
